import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import CustomBlock from '../const/CustomBlocks'
import useLocalStorage from '../lib//hooks/useLocalStorage'
import { getContentfulDirectClient } from '../lib/apollo-client'
import RIBBON_SITEWIDE_MESSAGE_QUERY from '../lib/schema/ribbonSitewideMessage.graphql'
import SITEWIDE_MESSAGE_QUERY from '../lib/schema/sitewideMessage.graphql'
import Footer from './NavigationComponents/Footer'
import Header from './NavigationComponents/Header'

export default function Layout({
  testId = 'layout',
  children,
  paywall,
  grey = false,
}) {
  const [ribbonSetting, setRibbonSetting] = useLocalStorage('ribbonSetting', {
    closed: false,
  })

  const [sitewideMessageProps, setSitewideMessageProps] = useState({})
  const [ribbonSitewideMessageProps, setRibbonSitewideMessageProps] =
    useState(null)
  const [ribbonHeight, setRibbonHeight] = useState(0)

  useEffect(() => {
    const fetchSitewideProps = async () => {
      try {
        const contentfulDirectClient = await getContentfulDirectClient()
        const sitewideMessageData = await contentfulDirectClient.query({
          query: SITEWIDE_MESSAGE_QUERY,
          variables: {
            preview: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW === 'true',
          },
        })
        setSitewideMessageProps(
          sitewideMessageData.data.siteWideMessageCollection || {}
        )
      } catch (err) {
        console.log(err)
      }
    }
    fetchSitewideProps()

    const fetchRibbonSitewideProps = async () => {
      try {
        const contentfulDirectClient = await getContentfulDirectClient()
        const ribbonSitewideMessageData = await contentfulDirectClient.query({
          query: RIBBON_SITEWIDE_MESSAGE_QUERY,
          variables: {
            preview: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW === 'true',
          },
        })
        setRibbonSitewideMessageProps(
          ribbonSitewideMessageData.data.ribbonSiteWideMessageCollection || {}
        )
      } catch (err) {
        console.log(err)
      }
    }
    fetchRibbonSitewideProps()
  }, [])

  return (
    <Box data-testid={testId}>
      {!!ribbonSitewideMessageProps?.items?.[0]?.text && (
        <CustomBlock
          item={ribbonSitewideMessageProps}
          ribbonSetting={ribbonSetting}
          setRibbonSetting={setRibbonSetting}
          setRibbonHeight={setRibbonHeight}
        />
      )}

      <Header
        style={{
          top: ribbonHeight + 'px',
        }}
      />
      <Box
        component='main'
        data-testid={`${testId}-content`}
        id='mainContent'
        sx={{
          marginTop: {
            xs: ribbonHeight + 56 + 'px',
            md: ribbonHeight + 116 + 'px',
          },
        }}
      >
        {children}
      </Box>

      <Footer grey={grey} />
      {paywall && (
        <Box
          id='piano-three-quarters-wall'
          sx={{
            width: '100%',
            position: 'fixed',
            bottom: 0,
            zIndex: 1,
          }}
        />
      )}
      {paywall && (
        <Box
          id='piano-bottom-ribbon'
          sx={{
            width: '100%',
            position: 'fixed',
            bottom: 0,
          }}
        />
      )}
      {!!sitewideMessageProps?.items?.[0]?.onOffSwitch && (
        <CustomBlock item={sitewideMessageProps} />
      )}
    </Box>
  )
}
